import { Fragment, useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import {
    cargarCategoriasInventario,
    cargarProveedoresInventario,
    cargarSubcategoriasInventario,
    listarInventario,
    setFiltrosInventario
} from '../../../actions/inventario';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const toOption = (item) => ({
    value: item?._id || item?.id || '',
    label: item?.nombre || 'Sin definir'
});

const FiltrosAvanzadosModal = ({ show, onHide }) => {
    const dispatch = useDispatch();

    const { categorias, subcategorias, proveedores, filtros } = useSelector((state) => state.inventario);

    const [categoria, setCategoria] = useState(null);
    const [subcategoria, setSubcategoria] = useState(null);
    const [proveedor, setProveedor] = useState(null);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (provided) => ({ ...provided }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: "visible",
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    useEffect(() => {
        if (!show) return;

        dispatch(cargarCategoriasInventario());
        dispatch(cargarProveedoresInventario());

        const cat = filtros?.id_categoria
            ? (categorias || []).find((c) => (c?._id || c?.id) === filtros.id_categoria)
            : null;

        const prov = filtros?.id_proveedor
            ? (proveedores || []).find((p) => (p?._id || p?.id) === filtros.id_proveedor)
            : null;

        setCategoria(cat ? toOption(cat) : null);
        setProveedor(prov ? toOption(prov) : null);
    }, [show, dispatch]);

    useEffect(() => {
        if (!show) return;

        if (categoria?.value) {
            dispatch(cargarSubcategoriasInventario(categoria.value));
        } else {
            setSubcategoria(null);
        }
    }, [categoria, show, dispatch]);

    useEffect(() => {
        if (!show) return;

        const sub = filtros?.id_subcategoria
            ? (subcategorias || []).find((s) => (s?._id || s?.id) === filtros.id_subcategoria)
            : null;

        setSubcategoria(sub ? toOption(sub) : null);
    }, [subcategorias, filtros, show]);

    const opcionesCategorias = useMemo(() => (categorias || []).map(toOption), [categorias]);
    const opcionesSubcategorias = useMemo(() => (subcategorias || []).map(toOption), [subcategorias]);
    const opcionesProveedores = useMemo(() => (proveedores || []).map(toOption), [proveedores]);

    const onBuscar = async () => {
        const nuevosFiltros = {
            id_categoria: categoria?.value || '',
            id_subcategoria: subcategoria?.value || '',
            id_proveedor: proveedor?.value || ''
        };

        await dispatch(setFiltrosInventario(nuevosFiltros));
        await dispatch(listarInventario(nuevosFiltros));
        onHide();
    };

    const onChangeCategoria = (opt) => {
        setCategoria(opt);
        setSubcategoria(null);
    };

    return (
        <Fragment>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Filtros avanzados</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="mb-3">
                        <Select
                            name="categoria"
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder={'Categoría'}
                            options={opcionesCategorias}
                            value={categoria}
                            isClearable={true}
                            onChange={onChangeCategoria}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{
                                ValueContainer: CustomValueContainer
                            }}
                            styles={{ ...styles_select }}
                        />
                    </div>

                    <div className="mb-3">
                        <Select
                            name="subcategoria"
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder={'Sucategoría'}
                            options={opcionesSubcategorias}
                            value={subcategoria}
                            isClearable={true}
                            isDisabled={!categoria?.value}
                            onChange={(opt) => setSubcategoria(opt)}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{
                                ValueContainer: CustomValueContainer
                            }}
                            styles={{ ...styles_select }}
                        />
                    </div>

                    <div className="mb-3">
                        <Select
                            name="proveedor"
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder={'Proveedor'}
                            options={opcionesProveedores}
                            value={proveedor}
                            isClearable={true}
                            onChange={(opt) => setProveedor(opt)}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{
                                ValueContainer: CustomValueContainer
                            }}
                            styles={{ ...styles_select }}
                        />
                    </div>

                    <div className="d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onHide}
                        >
                            Cancelar
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={onBuscar}
                        >
                            Buscar
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

export default FiltrosAvanzadosModal;
